<div
  *ngIf="!showDelete"
  class="package-tile-form-container clickable"
>
  <div class="row no-gutters">
    <div class="col-auto">
      <mat-checkbox
        #package
        aria-label="selectPackageItem"
        [checked]="packageItem.isSelected"
        (change)="package.checked !== isCategorySelected && toggleSelected()"
        class="package-checkbox"
      ></mat-checkbox>
    </div>
    <div class="col" (click)="toggleSelected()">
      <ng-container *ngIf="packageItem">
        <div class="row no-gutters">
          <div class="service-tile-form-content col-8 pr-3 oswald">{{ packageItem.name }}
            <span
              *ngIf="packageItem.description"
              class="package-description">{{ packageItem.description }}
            </span>
          </div>
          <div class="package-price col oswald">{{ packageItem?.price | currency }}
          </div>
        </div>
        <div
          *ngFor="let subItem of packageItem.items"
          class="row no-gutters subtext"
        >
          <div class="service-tile-form-content col-8 pr-3 lato">{{ subItem.item.displayName}}
          </div>
          <div class="package-price col lato">x {{ subItem.quantity }}
          </div>

        </div>
      </ng-container>
    </div>

  </div>
</div>

<div *ngIf="showDelete">
  <div class="package-tile-form-container-delete">
    <div class="row no-gutters">
        <ng-container *ngIf="packageItem">
          <div class="col package-info">
            <div class="row">
              <div class="ml-3 service-tile-form-content col-8 pr-3 package-tile-col-delete oswald">{{ packageItem.name }}
                <span
                  *ngIf="packageItem.description"
                  class="package-description">{{ packageItem.description }}
                </span>
              </div>
              <div class="package-price col package-tile-col-delete oswald">{{ packageItem?.price | currency }}
              </div>
            </div>
            <div
              *ngFor="let subItem of packageItem.items"
              class="row no-gutters subtext lato"
            >
              <div class="ml-3 col-8 pr-3">{{ subItem.item?.displayName}}
                (${{subItem?.item.price}} x {{subItem.quantity}})
                <div *ngIf="subItem?.item.taxable" class="taxable bold">taxable</div>

              </div>
              <div class="package-price col value">{{ subItem.value | currency }}
              </div>
            </div>
          </div>

            <div
              class="col-auto package-tile-col-delete delete-right clickable"
              (click)="toggleSelected()"
            >
              <img
                src="../../../../assets/svg/ico_trash_can.svg"
                tabindex="0"
                alt="Check Icon"
                height="20"
              >
            </div>
        </ng-container>
    </div>
  </div>
</div>
